/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import styles from './Heading.module.scss';
import '../Utils/css';

export default function Heading({
  anchor = null, type = 'inherit', tag = 'h2', children, compact = false, className = null,
}) {
  const HeadingTag = tag;
  const style = () => {
    if (type !== 'inherit') {
      return type;
    }

    return tag;
  };

  function slugify(str) {
    return String(str)
      .normalize('NFKD') // split accented characters into their base characters and diacritical marks
      .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
      .trim() // trim leading or trailing whitespace
      .toLowerCase() // convert to lowercase
      .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
      .replace(/\s+/g, '-') // replace spaces with hyphens
      .replace(/-+/g, '-'); // remove consecutive hyphens
  }

  return (
    <HeadingTag
      id={anchor ? slugify(anchor) : null}
      className={[
        styles.heading,
        styles[`--${style()}`],
        compact ? styles['--compact'] : '',
        className,
      ].css()}
    >
      {children}
    </HeadingTag>
  );
}

Heading.styles = {
  center: styles['--center'],
  bold: styles['--bold'],
};

Heading.propTypes = {
  /**
   * Anchor to use. Needs to be a unique id
   */
  anchor: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  children: PropTypes.node,
  /**
   * Style of heading
   */
  type: PropTypes.oneOf(['text', 'inherit', 'h1', 'h2', 'h3', 'h4']),
  /**
   * Type of tag to use for heading
   */
  tag: PropTypes.oneOf(['div', 'h1', 'h2', 'h3', 'h4']),
  /**
   * Removes top margin
   */
  compact: PropTypes.bool,
  /**
   * Additional CSS class names for custom styling.
   */
  className: PropTypes.string,
};
